import { usePermissions } from '../../hooks/usePermissions';

const PermissionGate = ({ 
  children, 
  requireAdmin = false, 
  requireGroups = [],
  fallback = null 
}) => {
  const { isAdmin, groups } = usePermissions();

  // Verificar se tem permissão admin quando necessário
  if (requireAdmin && !isAdmin) {
    return fallback;
  }

  // Verificar se está em algum dos grupos necessários
  if (requireGroups.length > 0) {
    const hasRequiredGroup = requireGroups.some(group => groups.includes(group));
    if (!hasRequiredGroup) {
      return fallback;
    }
  }

  return children;
};

export default PermissionGate;